module.exports = __webpack_public_path__ + "static/media/telcos-2.6a5633d8.png";